import { forwardRef, useMemo } from 'react';

import { GridContainerRoot } from './GridContainer.styles';
import type { GridContainerProps } from './GridContainer.types';

const defaultProps: GridContainerProps = {
  templateColumns: 12,
  templateRows: 0,
};

export const GridContainer = forwardRef<HTMLDivElement, GridContainerProps>((props, ref) => {
  const {
    component = 'div',
    templateColumns: templateColumnsProp = defaultProps.templateColumns,
    templateRows: templateRowsProp,
    variant,
    ...otherProps
  } = props;

  const templateColumns = useMemo<GridContainerProps['templateColumns']>(() => {
    if (typeof templateColumnsProp === 'undefined' || templateColumnsProp === ('undefined' as unknown)) {
      return defaultProps.templateColumns;
    }
    return templateColumnsProp;
  }, [templateColumnsProp]);

  const templateRows = useMemo<GridContainerProps['templateRows']>(() => {
    if (typeof templateRowsProp === 'undefined' || templateRowsProp === ('undefined' as unknown)) {
      return defaultProps.templateRows;
    }
    return templateRowsProp;
  }, [templateRowsProp]);

  return (
    <GridContainerRoot
      component={component}
      templateColumns={templateColumns}
      templateRows={templateRows}
      variant={variant}
      {...otherProps}
      ref={ref}
    />
  );
});

GridContainer.displayName = 'GridContainer';
